import MainNavigation from "../../components/Navigation/MainNavigation";
import SectionNine from "./SectionNine";
import React from "react";

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
    padding: "56px 16px",
    color: "#101828",
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif',
  },
  container: {
    maxWidth: 960,
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 18,
    border: "1px solid #EAECF0",
    boxShadow: "0 14px 40px rgba(16, 24, 40, 0.08)",
    padding: "28px 22px",
  },
  header: {
    textAlign: "center",
    marginBottom: 26,
  },
  title: {
    fontSize: 36,
    fontWeight: 800,
    letterSpacing: "-0.02em",
    margin: "10px 0 6px",
  },
  updated: {
    fontSize: 13,
    color: "#667085",
    margin: 0,
    fontWeight: 600,
  },
  intro: {
    fontSize: 15.5,
    lineHeight: 1.75,
    color: "#344054",
    margin: "14px auto 0",
    maxWidth: 760,
  },
  note: {
    margin: "18px auto 0",
    maxWidth: 760,
    backgroundColor: "#F2F4F7",
    border: "1px solid #EAECF0",
    borderRadius: 12,
    padding: "12px 14px",
    fontSize: 14,
    lineHeight: 1.6,
    color: "#101828",
    fontWeight: 600,
  },
  section: {
    marginTop: 26,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 800,
    margin: "0 0 10px",
    color: "#101828",
  },
  divider: {
    height: 1,
    width: "100%",
    backgroundColor: "#EAECF0",
    margin: "10px 0 16px",
  },
  subTitle: {
    fontSize: 15,
    fontWeight: 800,
    margin: "16px 0 8px",
    color: "#1D2939",
  },
  paragraph: {
    fontSize: 15.5,
    lineHeight: 1.75,
    color: "#344054",
    margin: "0 0 12px",
  },
  list: {
    margin: "0 0 12px",
    paddingLeft: 22,
    color: "#344054",
    lineHeight: 1.75,
    fontSize: 15.5,
  },
  listItem: {
    marginBottom: 8,
  },
  link: {
    color: "#027EC2",
    fontWeight: 700,
    textDecoration: "none",
  },
  linkHoverHint: {
    color: "#027EC2",
    fontWeight: 700,
    textDecoration: "underline",
  },
  contactBox: {
    marginTop: 10,
    backgroundColor: "#E6F5FE",
    border: "1px solid #B7E2FA",
    borderRadius: 14,
    padding: "14px 14px",
  },
  contactTitle: {
    margin: 0,
    fontSize: 15,
    fontWeight: 800,
    color: "#012030",
  },
  contactText: {
    margin: "6px 0 0",
    fontSize: 14.5,
    lineHeight: 1.7,
    color: "#012030",
  },
  footer: {
    marginTop: 18,
    fontSize: 13,
    color: "#667085",
    textAlign: "center",
  },
};


function Privacy() {
    const [hover, setHover] = React.useState(false);
  return (
      <><><MainNavigation /><div style={styles.page}>

          <div style={styles.container}>
              <div style={styles.card}>
                  {/* Header */}
                  <div style={styles.header}>
                      <p style={styles.updated}>Last updated on 19/01/2025</p>
                      <h1 style={styles.title}>Privacy Policy</h1>

                      <p style={styles.intro}>
                          At <strong>DataUp Gaming</strong>, we are dedicated to safeguarding the privacy and
                          security of your personal information. This Privacy Policy outlines how we collect,
                          use, disclose, and protect the information you provide when using our platform,
                          products, and services (collectively, the “Services”).
                      </p>

                      <div style={styles.note}>
                          By using our Services, you agree to the practices described in this Privacy Policy.
                      </div>
                  </div>

                  {/* 1 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>1. Information We Collect</h2>
                      <div style={styles.divider} />

                      <p style={styles.paragraph}>
                          We collect the following types of information to provide and enhance our Services:
                      </p>

                      <div>
                          <h3 style={styles.subTitle}>(a) Personal Information</h3>
                          <ul style={styles.list}>
                              <li style={styles.listItem}>
                                  <strong>Account Information:</strong> Name, email address, username, and contact
                                  details.
                              </li>
                              <li style={styles.listItem}>
                                  <strong>Payment Information:</strong> Payment method details, billing information,
                                  and transaction history.
                              </li>
                          </ul>

                          <h3 style={styles.subTitle}>(b) Usage Information</h3>
                          <ul style={styles.list}>
                              <li style={styles.listItem}>
                                  Activity logs, including browsing history, search queries, and interactions within
                                  our platform.
                              </li>
                              <li style={styles.listItem}>
                                  Preferences and settings you configure on our platform.
                              </li>
                          </ul>

                          <h3 style={styles.subTitle}>(c) Device Information</h3>
                          <ul style={styles.list}>
                              <li style={styles.listItem}>
                                  IP address, device type, operating system, browser type, and device identifiers.
                              </li>
                          </ul>

                          <h3 style={styles.subTitle}>(d) Other Information You Provide</h3>
                          <ul style={styles.list}>
                              <li style={styles.listItem}>
                                  Information you share with us through customer support inquiries, feedback, or
                                  surveys.
                              </li>
                          </ul>
                      </div>
                  </section>

                  {/* 2 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>2. How We Use Your Information</h2>
                      <div style={styles.divider} />

                      <p style={styles.paragraph}>
                          We use your personal information for the following purposes:
                      </p>

                      <h3 style={styles.subTitle}>(a) Service Delivery and Enhancement</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              To operate, maintain, and improve our platform and Services.
                          </li>
                          <li style={styles.listItem}>
                              To process transactions, facilitate payments, and manage accounts.
                          </li>
                      </ul>

                      <h3 style={styles.subTitle}>(b) Personalization</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              To customize and enhance your experience on our platform based on your preferences.
                          </li>
                      </ul>

                      <h3 style={styles.subTitle}>(c) Communication</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              To send service-related notifications, updates, marketing messages, and promotional
                              content.
                          </li>
                          <li style={styles.listItem}>
                              To respond to your inquiries and provide customer support.
                          </li>
                      </ul>

                      <h3 style={styles.subTitle}>(d) Analytics and Improvement</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              To monitor, analyze, and improve usage trends and functionality of our platform.
                          </li>
                      </ul>

                      <h3 style={styles.subTitle}>(e) Compliance</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              To comply with applicable legal obligations and enforce our terms of use or other
                              agreements.
                          </li>
                      </ul>
                  </section>

                  {/* 3 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>3. Sharing Your Information</h2>
                      <div style={styles.divider} />

                      <p style={styles.paragraph}>
                          We do not sell your personal information. However, we may share your data in the
                          following scenarios:
                      </p>

                      <h3 style={styles.subTitle}>(a) Service Providers and Partners</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              With third-party vendors, contractors, and partners who assist us in delivering our
                              Services, such as payment processors, hosting providers, and customer support tools.
                          </li>
                      </ul>

                      <h3 style={styles.subTitle}>(b) Legal Compliance</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              To comply with legal obligations, enforce our agreements, or respond to lawful
                              requests from public or governmental authorities.
                          </li>
                      </ul>

                      <h3 style={styles.subTitle}>(c) Corporate Transactions</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              In connection with business transfers, such as a merger, acquisition, or sale of
                              assets, where your information may be transferred as part of the transaction.
                          </li>
                      </ul>

                      <h3 style={styles.subTitle}>(d) Consent-Based Sharing</h3>
                      <ul style={styles.list}>
                          <li style={styles.listItem}>With your explicit consent for specific purposes.</li>
                      </ul>
                  </section>

                  {/* 4 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>4. Data Security</h2>
                      <div style={styles.divider} />
                      <p style={styles.paragraph}>
                          We implement industry-standard technical, administrative, and organizational measures
                          to protect your personal information from unauthorized access, loss, misuse, or
                          disclosure. While we strive to safeguard your data, no method of transmission over the
                          internet or electronic storage is entirely secure, and we cannot guarantee absolute
                          security.
                      </p>
                  </section>

                  {/* 5 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>5. Your Rights and Choices</h2>
                      <div style={styles.divider} />
                      <p style={styles.paragraph}>
                          You have the right to access, correct, or delete your personal information, as well as
                          to object to or restrict the processing of your data. You can exercise these rights by
                          contacting our support team at{" "}
                          <a
                              href="mailto:support@dataupgaming.com"
                              style={hover ? styles.linkHoverHint : styles.link}
                              onMouseEnter={() => setHover(true)}
                              onMouseLeave={() => setHover(false)}
                          >
                              support@dataupgaming.com
                          </a>
                          .
                      </p>
                  </section>

                  {/* 6 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>6. Cookies and Tracking Technologies</h2>
                      <div style={styles.divider} />
                      <p style={styles.paragraph}>
                          We use cookies and similar tracking technologies to enhance your experience on our
                          platform and collect information about usage trends and performance. You can manage or
                          disable cookies through your browser settings. However, disabling cookies may limit
                          your ability to use certain features of our platform.
                      </p>
                  </section>

                  {/* 7 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>7. Third-Party Links and Services</h2>
                      <div style={styles.divider} />
                      <p style={styles.paragraph}>
                          Our platform may include links to third-party websites, services, or applications. We
                          are not responsible for the privacy practices or content of these third-party
                          platforms. We encourage you to review their privacy policies before providing them
                          with your personal information.
                      </p>
                  </section>

                  {/* 8 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>8. Children’s Privacy</h2>
                      <div style={styles.divider} />
                      <p style={styles.paragraph}>
                          Our Services are not intended for individuals under the age of 13 (or the applicable
                          age of consent in your jurisdiction). We do not knowingly collect personal information
                          from children. If we discover that we have inadvertently collected information from a
                          child, we will promptly delete it. Parents or guardians may contact us at{" "}
                          <a
                              href="mailto:support@dataupgaming.com"
                              style={hover ? styles.linkHoverHint : styles.link}
                              onMouseEnter={() => setHover(true)}
                              onMouseLeave={() => setHover(false)}
                          >
                              support@dataupgaming.com
                          </a>{" "}
                          to request the removal of any information shared by their child.
                      </p>
                  </section>

                  {/* 9 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>9. Changes to this Privacy Policy</h2>
                      <div style={styles.divider} />
                      <p style={styles.paragraph}>
                          We may update this Privacy Policy periodically to reflect changes in our practices,
                          technology, or legal requirements. Any material changes will be communicated through
                          our platform or other means. The “Last Updated” date at the top of this policy
                          indicates when it was last revised.
                      </p>
                  </section>

                  {/* 10 */}
                  <section style={styles.section}>
                      <h2 style={styles.sectionTitle}>10. Contact Us</h2>
                      <div style={styles.divider} />

                      <div style={styles.contactBox}>
                          <p style={styles.contactTitle}>DataUp Gaming Support Team</p>
                          <p style={styles.contactText}>
                              Email:{" "}
                              <a
                                  href="mailto:support@dataupgaming.com"
                                  style={hover ? styles.linkHoverHint : styles.link}
                                  onMouseEnter={() => setHover(true)}
                                  onMouseLeave={() => setHover(false)}
                              >
                                  support@dataupgaming.com
                              </a>
                          </p>
                      </div>

                      <p style={styles.footer}>
                          Thank you for trusting DataUp Gaming. Your privacy is our priority.
                      </p>
                  </section>
              </div>
          </div>
      </div></><SectionNine /></>
  );
}

export default Privacy;